import { EnvironmentProviders } from '@angular/core';
import { Route } from '@angular/router';
import { AuthGuard, LoginCallbackComponent, LoginShellComponent } from '@iot-platform/auth';
import { provideIotPlatformApplicationState, provideIotPlatformBusinessProfileWhenReadRuleOnDeviceConfiguratorConceptState } from '@iot-platform/data-access';
import { NavigationRoutes } from '@iot-platform/models/common';

export function provideBamApplicationState(): EnvironmentProviders[] {
  return [].concat(provideIotPlatformApplicationState(), provideIotPlatformBusinessProfileWhenReadRuleOnDeviceConfiguratorConceptState());
}

export const APP_ROUTES: Route[] = [
  {
    path: NavigationRoutes.LOGIN,
    children: [
      {
        path: '',
        component: LoginShellComponent
      },
      {
        path: NavigationRoutes.LOGIN_CALLBACK,
        component: LoginCallbackComponent
      }
    ],
    providers: [provideBamApplicationState()]
  },
  {
    path: '',
    loadChildren: () => import('@iot-platform/bam/feature/app-shell').then((m) => m.AppShellRoutes),
    canActivate: [AuthGuard],
    providers: [provideBamApplicationState()]
  },
  { path: NavigationRoutes.HOME, redirectTo: `/${NavigationRoutes.DEVICES}` },
  { path: '', redirectTo: `/${NavigationRoutes.HOME}`, pathMatch: 'full' },
  { path: '**', redirectTo: `/${NavigationRoutes.HOME}` }
];
